import { apiWithToken } from '../api';

const resouceUrl = '/projeto_processo';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const show = async (id) => {
  return await api.get(`${resouceUrl}/${id}`);
}

export const update = async (id, projeto_processo) => {
  return await api.put(`${resouceUrl}/${id}`, projeto_processo);
}
export const update_parecer = async (id, projeto_processo) => {
  return await api.put(`${resouceUrl}/${id}/update_parecer`, projeto_processo);
}


export const store = async (projeto_processo) => {
  let response = await api.post(resouceUrl , projeto_processo);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}
